(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".faq-item");

  items.forEach(item => {
    const question = item.querySelector(".faq-question");
    const icon = item.querySelector("i");
    const answer = item.querySelector(".faq-answer");

    question.addEventListener("click", () => {
      items.forEach(i => {
        i.classList.remove("active");
        i.querySelector(".faq-answer").style.display = "none";
        const iconInside = i.querySelector("i");
        if (iconInside) {
          iconInside.classList.remove("fa-angle-up");
          iconInside.classList.add("fa-angle-down");
        }
      });

      item.classList.add("active");
      answer.style.display = "block";
      if (icon) {
        icon.classList.remove("fa-angle-down");
        icon.classList.add("fa-angle-up");
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".custom-faq-item");

  items.forEach((item) => {
    const question = item.querySelector(".custom-faq-question");
    const answer = item.querySelector(".custom-faq-answer");
    const icon = item.querySelector("i");

    question.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      // Close all
      items.forEach((i) => {
        i.classList.remove("active");
        const ans = i.querySelector(".custom-faq-answer");
        const icn = i.querySelector("i");
        ans.style.maxHeight = "0px";
        ans.style.paddingBottom = "0";
        if (icn) {
          icn.classList.remove("fa-angle-up");
          icn.classList.add("fa-angle-down");
        }
      });

      // If not open already, open it
      if (!isOpen) {
        item.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.paddingBottom = "20px";
        if (icon) {
          icon.classList.remove("fa-angle-down");
          icon.classList.add("fa-angle-up");
        }
      }
    });

    // Set default open item
    if (item.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.style.paddingBottom = "20px";
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-with-image"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll(".tab-btn").forEach(btn => {
  btn.addEventListener("click", () => {
    document.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
    document.querySelectorAll(".tab-panel").forEach(p => p.classList.remove("active"));

    btn.classList.add("active");
    const target = btn.dataset.tab;
    document.querySelector('.tab-panel[data-tab="' + target + '"]').classList.add("active");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  let currentIndex = 0;
  let interval;

  function showSlide(index) {
    const slides = document.querySelectorAll('.testimonial-carousel-item');
    if (index >= slides.length) {
      currentIndex = 0;
    } else if (index < 0) {
      currentIndex = slides.length - 1;
    } else {
      currentIndex = index;
    }
    const offset = -currentIndex * 100;
    const carouselInner = document.querySelector('.testimonial-carousel-inner');
    if (carouselInner) {
      carouselInner.style.transform = `translateX(${offset}%)`;
    } else {
      console.error('Carousel inner element not found.');
    }
  }

  function changeSlide(step) {
    showSlide(currentIndex + step);
  }

  function startAutoSlide() {
    interval = setInterval(() => {
      changeSlide(1);
    }, 10000); // Change slide every 10 seconds
  }

  function stopAutoSlide() {
    clearInterval(interval);
  }

  // Initialize the first slide
  showSlide(currentIndex);
  startAutoSlide();

  // Expose changeSlide function to global scope
  window.changeSlide = changeSlide;

  // Pause auto-slide on hover
  const carousel = document.querySelector('.testimonial-carousel');
  if (carousel) {
    carousel.addEventListener('mouseenter', stopAutoSlide);
    carousel.addEventListener('mouseleave', startAutoSlide);
  }

  // Update mobile background image on screen resize
  function updateMobileBg() {
    const slides = document.querySelectorAll('.testimonial-carousel-item');
    slides.forEach(slide => {
      if (window.innerWidth <= 600) {
        const mobileBg = slide.getAttribute('data-mobile-bg');
        if (mobileBg) {
          slide.style.backgroundImage = `url(${mobileBg})`;
        }
      } else {
        const bgImage = slide.style.backgroundImage.match(/url\(([^)]+)\)/);
        if (bgImage) {
          slide.style.backgroundImage = `url(${bgImage[1]})`;
        }
      }
    });
  }

  window.addEventListener('resize', updateMobileBg);
  updateMobileBg(); // Initial check
});


  } catch(e) { console.error(e); }
})();
})();
